import { useEffect } from 'react';

export const DEFAULT_PAGE_TITLE = 'Help from Sky';

type BusinessNameSource = { business_name?: string | null } | null | undefined;

function resolveBusinessName(source?: BusinessNameSource): string | undefined {
  return source?.business_name ?? undefined;
}

export function getBusinessPageTitle(source?: BusinessNameSource): string {
  const trimmed = resolveBusinessName(source)?.trim();
  return trimmed ? trimmed : DEFAULT_PAGE_TITLE;
}

export function useBusinessPageTitle(source?: BusinessNameSource) {
  const business_name = resolveBusinessName(source);
  useEffect(() => {
    document.title = getBusinessPageTitle({ business_name });
  }, [business_name]);
}
